module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19AnrQf/tc-custom/9781683355151.jpg?1700294074078",
      "alt": "This image is the cover for the book Painting with Wool"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Painting with Wool\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Learn how to needle felt and create stunning works of fiber art to wear, hang on the wall, and more with this guide and collection of sixteen projects.")]), _c('br'), _c('br'), _c('i', [_vm._v("Painting with Wool ")]), _vm._v("is the introductory and must-have text for fiber artists and other crafters looking for a new and exciting art form to explore. Increasingly popular, Dani Ives’s style of needle felting uses wool fibers and a felting needle to layer and “paint” embellishments for pieces that are bursting with texture and depth. Whether you want to decorate a tote or garment, or create frameable artwork, "), _c('i', [_vm._v("Painting with Wool ")]), _vm._v("is the guide to everything you need to know—including the tools required, the basic techniques, and how to get started. For fiber lovers who want to broaden their skills, needle felting is an easy, therapeutic form of self-expression that offers beautiful, unique results. Ives is a pioneer in this art form and a skilled instructor who makes learning this craft fun and approachable for all.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dani Ives\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dani Ives is a sought-after teacher who hosts workshops and studio courses online and in person. She lives in Rogers, Arkansas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Abrams Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0